import type { TFunction } from 'i18next'
import { z } from 'zod'

import {
  MaxNoteLength,
  MeaningfulNoteLength,
  OptionalNoteSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { isFormattedTextLengthValid } from '../refinements/formatted-text.ts'

export const BrandFeedbackPostProdFormModelSchema = (
  t: TFunction<'validation'>
) =>
  z.discriminatedUnion('status', [
    z.object({
      status: z.literal('changes_requested'),
      note: z.string().superRefine((val, ctx) =>
        isFormattedTextLengthValid(
          t,
          t('brand-feedback-post-prod-review.note.label'),
          {
            min: MeaningfulNoteLength,
            max: MaxNoteLength,
          }
        ).refinement(val, ctx)
      ),
    }),
    z.object({
      status: z.literal('approved'),
      note: z.string().optional(),
    }),
  ])

export const MakerProposalPostProdUpdateFormModelSchema = z.object({
  note: OptionalNoteSchema,
})

export type MakerProposalPostProdUpdateFormModel = ZodInfer<
  typeof MakerProposalPostProdUpdateFormModelSchema
>
